import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import {
  Brand,
  LOGO_FOLDER,
  LOGO_MAPPING,
  LogoType,
  Trademark,
} from '@design-system';
import { Nil } from '@model';
import { isNil } from 'lodash-es';

@Component({
  selector: 'etn-logo',
  templateUrl: `./logo.component.html`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LogoComponent implements OnChanges {
  @Input() public brand: Brand | Nil;
  @Input() public type: LogoType | Nil;
  @Input() public height: number | Nil = undefined;
  @Input() public trademark: Trademark | Nil;

  public src = '';
  public svgStyle: Record<string, any> = this.getSvgStyle(this.height);

  public ngOnChanges(): void {
    if (isNil(this.brand)) {
      this.src = '';
    } else {
      if (isNil(this.trademark)) {
        this.src = `${LOGO_FOLDER}/${this.brand}/${
          LOGO_MAPPING[this.brand][this.type ?? LogoType.Primary]
        }`;
      } else {
        this.src = `${LOGO_FOLDER}/${this.brand}/${this.trademark}/${
          LOGO_MAPPING[this.trademark][this.type ?? LogoType.Primary]
        }`;
      }
    }
    this.svgStyle = this.getSvgStyle(this.height);
  }

  private getSvgStyle(height: number | Nil): Record<string, any> {
    if (isNil(height)) {
      return {
        display: 'block',
      };
    }
    return {
      display: 'block',
      'height.px': height,
    };
  }
}
